import React, { useRef } from 'react'
import { Badge, Button, SimpleModal, SimpleStat, Stack, Text } from '@/components/lib'
import useStore from '@/store'
import utils from '@/utils/utils'
import ResponseViewer from '@/components/includes/ResponseViewer'

// The read-only view of a single questionnaire response: the submission's own
// stats, then its answers. Shared by the Questionnaires tab, which lists a
// stage's responses, and the signed-consents list, which opens the screening
// that followed a consent — so the two show a response identically.
export default function QuestionnaireResponseModal ({ isOpen, onClose, response, queries, setQueries, responseValidations, setResponseValidations, canReadPii, highlightDataTypeId }) {
  const { dataTypes } = useStore()
  const modalRef = useRef(null) // Used to handle popovers in modals
  if (!response) return null

  return (
    <SimpleModal
      isOpen={isOpen}
      onClose={onClose}
      header='Questionnaire response'
      size='xl'
      body={
        <Stack gap={5} ref={modalRef}>
          <Stack>
            <Stack direction={{ base: 'column', md: 'row' }} justifyContent='space-between'>
              <SimpleStat name='Submitted at' number={utils.formatDateTime(response.createdAt)} />
              {(response.score || response.score === 0) && <SimpleStat name='Total score' number={response.score || 'N/A'} />}
              {response.status && (
                <SimpleStat
                  name='Status'
                  number={
                    <Badge colorPalette={response.status === 'successful' ? 'green' : 'red'}>
                      {response.status}
                    </Badge>
                  }
                />
              )}
              {canReadPii && (response.email || response.phone) &&
                <SimpleStat
                  name='Contact details' number={
                    <Stack>
                      {response.email && <Text><a href={`mailto:${response.email}`}>{response.email}</a></Text>}
                      {response.phone && <Text>{response.phone}</Text>}
                    </Stack>
                }
                />}
            </Stack>
          </Stack>
          <Stack>
            <ResponseViewer
              queryRaiserPortalRef={modalRef}
              highlightDataTypeId={highlightDataTypeId}
              response={response}
              dataTypes={dataTypes}
              queries={queries}
              setQueries={setQueries}
              responseValidations={responseValidations}
              setResponseValidations={setResponseValidations}
            />
          </Stack>
        </Stack>
      }
      footer={
        <Button colorPalette='primary' onClick={onClose}>Close</Button>
      }
    />
  )
}
